import { combineReducers } from 'redux'
import languageReducer from './languages'
import userReducer from './user'

const allReducers = combineReducers({
    language: languageReducer,
    user: userReducer,
})

export default allReducers